import {Component, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {CoffeeConfig} from '../../../classes/CoffeeConfig';
import {CoffeeConfigService} from '../../../services/coffee-config.service';
import {CoffeeConfigEditComponent} from '../coffee-config-edit/coffee-config-edit.component';
import {Office} from '../../../classes/Office';
import {OfficeService} from '../../../services/office.service';

@Component({
  selector: 'app-coffee-config-list',
  styleUrls: ['./coffee-config-list.component.scss'],
  templateUrl: './coffee-config-list.component.html',
})
export class CoffeeConfigListComponent implements OnInit {

  public coffeeConfigs: CoffeeConfig[];
  public errorMessage: string;
  private currentDialog = null;
  private offices: Map<number, Office>;

  constructor(private coffeeConfigService: CoffeeConfigService,
              private modalService: NgbModal,
              private officeService: OfficeService) {
  }

  ngOnInit(): void {
    this.updateList();

    this.officeService.getAll()
      .subscribe((response: Office[]) => this.offices = new Map(response.map(office => [office.id, office])));
  }

  private updateList(): void {
    this.coffeeConfigService.getAll()
      .subscribe({
        next: (response: CoffeeConfig[]) => this.coffeeConfigs = response,
        error: (error) => this.errorMessage = error.error.error
      });
  }

  openEditModal(coffeeConfig: CoffeeConfig): void {
    this.currentDialog = this.modalService.open(CoffeeConfigEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-coffee-config-edit',
        size: 'md',
        centered: true,
      });

    this.currentDialog.componentInstance.coffeeConfig = coffeeConfig;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedCoffeeConfig = new CoffeeConfig(result.value);

          this.coffeeConfigService.addOrEdit(editedCoffeeConfig).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(coffeeConfig: CoffeeConfig): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete config ' + coffeeConfig.id + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.coffeeConfigService.delete(coffeeConfig.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  getOffice(officeId: number): string {
    const office = this.offices.get(officeId);
    return office.city + ', ' + office.address;
  }
}
